import {Component, OnDestroy, OnInit} from '@angular/core';
import {Location} from '@angular/common';

import {TranslateService} from '@ngx-translate/core';

import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {FuseConfigService} from '@fuse/services/config.service';
import {FuseNavigationService} from '@fuse/components/navigation/navigation.service';
import {FuseSidebarService} from '@fuse/components/sidebar/sidebar.service';
import {FuseSplashScreenService} from '@fuse/services/splash-screen.service';
import {FuseTranslationLoaderService} from '@fuse/services/translation-loader.service';

import {MessagingService} from '@sip/common/services/messaging.service';
import {ThemeConfigService} from '@sip/common/config/theme-config.service';
import {navigationAuth, navigationGuest} from './navigation';
import {ChatStoreService} from './shared/services/chat.store.service';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    navigation: any;
    fuseConfig: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {FuseSplashScreenService} _fuseSplashScreenService
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     * @param {TranslateService} _translateService
     * @param _chatStore
     * @param _location
     * @param _messageService
     */
    constructor(private _fuseConfigService: FuseConfigService,
                private _fuseNavigationService: FuseNavigationService,
                private _fuseSidebarService: FuseSidebarService,
                private _fuseSplashScreenService: FuseSplashScreenService,
                private _fuseTranslationLoaderService: FuseTranslationLoaderService,
                private _translateService: TranslateService,
                private _chatStore: ChatStoreService,
                private _location: Location,
                private _configTheme: ThemeConfigService,
                private _messageService: MessagingService) {
        // Get default navigation
        this.navigation = navigationGuest;

        // Register the navigation to the service
        this._fuseNavigationService.register('main', this.navigation);
        this._fuseNavigationService.register('authenticated', navigationAuth);

        // Set the main navigation as our current navigation
        this._fuseNavigationService.setCurrentNavigation('main');

        // Add languages
        this._translateService.addLangs(['en']);

        // Set the default language
        this._translateService.setDefaultLang('en');

        // Set the navigation translations
        // this._fuseTranslationLoaderService.loadTranslations(navigationEnglish, navigationTurkish);

        // Use a language
        this._translateService.use('en');

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.fuseConfig = config;
            });

        this.registerCloudMessaging();

        // Tema/logo da marca: ativa o store e já carrega a logo da empresa no bootstrap,
        // antes de qualquer código de sessão (corrige a tela inicial mostrando a logo SIP).
        this._configTheme.bind();
        this._configTheme.requestSkinTheme();

        this._chatStore.onNewMessage()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(m => {
                if (this._location.path() !== '/sessao/perguntar') {
                    this._chatStore.showSnackNewMessage();
                }
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    private registerCloudMessaging(): void {
        this._messageService.receiveMessage();

        this._messageService.currentMessage.subscribe(m => {
        });

    }
}
